import { render, staticRenderFns } from "./effects.vue?vue&type=template&id=26f634ec&scoped=true"
import script from "./effects.vue?vue&type=script&lang=js"
export * from "./effects.vue?vue&type=script&lang=js"
import style0 from "./effects.vue?vue&type=style&index=0&id=26f634ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f634ec",
  null
  
)

export default component.exports